<template>
  <div class="layout">
        <header>
            <router-link :to="{ path: '/' }">
                <div class="header logo">
                    <img alt="Vue logo" src="../assets/truecaller.svg">
                </div>
            </router-link>
        </header>
    </div>
</template>

<script>

export default {
  name: 'NavigationBar'
}
</script>
<style scoped>
.header{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 11px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--white);
    z-index: 1;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    background-color: var(--truecaller-background)
}
.logo{
    position: relative;
    display: inline-block;
    text-decoration: none;
}
img{
    width: auto;
    height: auto;
}
@media screen and (min-width: 768px) {
  img{
        max-width:125px;
        max-height:95px;
    }
}
@media only screen and (max-width: 600px) {
    img{
        max-width:90px;
        max-height:95px;
    }
}

</style>
